export default "/images/vendor/flag-icons/flags/1x1/sl.svg?ec1ec422fd5ac1515437684af48ecba4";